import { render, staticRenderFns } from "./GrabOrderConfig.vue?vue&type=template&id=20ee18e2&scoped=true&"
import script from "./GrabOrderConfig.vue?vue&type=script&lang=js&"
export * from "./GrabOrderConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ee18e2",
  null
  
)

export default component.exports